var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 485.86,
    height: 177.428,
    viewBox: "0 0 485.86 177.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(-115.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(305 43.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M40.6,146.416V184.29H36.047v-8.032a18.027,18.027,0,0,1-6.778,6.25,19.766,19.766,0,0,1-9.881,2.575,19.964,19.964,0,0,1-9.837-2.465,18.161,18.161,0,0,1-6.976-6.976A20.412,20.412,0,0,1,0,165.32,20.655,20.655,0,0,1,2.663,154.6a18.06,18.06,0,0,1,7.372-6.932,22.889,22.889,0,0,1,10.607-2.421,16.829,16.829,0,0,1,8.913,2.619,17.739,17.739,0,0,1,6.492,6.778l.484-8.23Zm-9.4,30.809a14.269,14.269,0,0,0,4.841-10.167v-5.436a15.418,15.418,0,0,0-5.612-8.913,15.729,15.729,0,0,0-10.167-3.587,16.18,16.18,0,0,0-7.944,1.981,14.642,14.642,0,0,0-5.678,5.612A16.576,16.576,0,0,0,4.555,165.1a15.619,15.619,0,0,0,2.135,8.032,16.159,16.159,0,0,0,5.766,5.854,15.1,15.1,0,0,0,7.9,2.179A15.74,15.74,0,0,0,31.205,177.2Z",
    transform: "translate(0 -109.624)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M34.166,138.21v17.143H45.9v3.675H34.166v33.714H29.522V159.028H21.49v-3.675h8.032V138.21h4.643Z",
    transform: "translate(25.802 -118.076)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M39.425,129.54v73.634H34.87V129.54h4.555Z",
    transform: "translate(41.867 -128.486)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M80.842,159.311v37.873H76.287v-8.032a18.027,18.027,0,0,1-6.778,6.25,19.765,19.765,0,0,1-9.881,2.575,19.964,19.964,0,0,1-9.837-2.465,18.16,18.16,0,0,1-6.976-6.976,20.412,20.412,0,0,1-2.575-10.321A20.655,20.655,0,0,1,42.9,167.5a18.06,18.06,0,0,1,7.372-6.932,22.889,22.889,0,0,1,10.607-2.421,16.829,16.829,0,0,1,8.913,2.619,17.739,17.739,0,0,1,6.492,6.778l.484-8.23h4.071Zm-9.4,30.809a14.269,14.269,0,0,0,4.841-10.167v-5.436a15.419,15.419,0,0,0-5.612-8.913,15.729,15.729,0,0,0-10.167-3.587A16.179,16.179,0,0,0,52.564,164a14.642,14.642,0,0,0-5.678,5.612A16.577,16.577,0,0,0,44.8,178a15.619,15.619,0,0,0,2.135,8.032,16.159,16.159,0,0,0,5.766,5.854,15.1,15.1,0,0,0,7.9,2.179A15.74,15.74,0,0,0,71.445,190.1Zm1.166-40.206-9.683-10.849-9.485,10.849H48.889l14.04-15.4h.088l14.15,15.4Z",
    transform: "translate(48.315 -122.519)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M92.533,148.435a11.433,11.433,0,0,1,3.5,8.186V184.24H91.388V157.876a9.486,9.486,0,0,0-2.421-6.162,8.646,8.646,0,0,0-6.4-2.465A14.136,14.136,0,0,0,70.2,156.291a14.6,14.6,0,0,0-1.981,7.614v20.356H63.66V146.388h3.983l.4,8.429a14.406,14.406,0,0,1,6.25-6.932,18.991,18.991,0,0,1,9.749-2.575,11.689,11.689,0,0,1,8.517,3.147Z",
    transform: "translate(76.434 -109.552)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M94.086,138.21v17.143h11.73v3.675H94.086v33.714H89.442V159.028H81.41v-3.675h8.032V138.21h4.643Z",
    transform: "translate(97.746 -118.076)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M99.5,154.833v37.873H94.946V154.833Zm-.154-16.593H95.32a.667.667,0,0,0-.66.682v4.027a.681.681,0,0,0,.66.682h4.027a.667.667,0,0,0,.66-.682v-4.027A.681.681,0,0,0,99.347,138.24Z",
    transform: "translate(113.655 -118.04)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M127.14,183.748A21.389,21.389,0,0,1,110,182.339a18.865,18.865,0,0,1-7.218-7.064,19.827,19.827,0,0,1-2.619-10.123,19.431,19.431,0,0,1,2.663-10.123,19.172,19.172,0,0,1,7.218-7.064,19.765,19.765,0,0,1,9.881-2.575,20.2,20.2,0,0,1,13.27,4.467l-2.421,3.1a16.9,16.9,0,0,0-10.563-3.785,14.709,14.709,0,0,0-7.79,2.135,15.8,15.8,0,0,0-5.612,5.81,16.081,16.081,0,0,0-2.091,8.032,15.8,15.8,0,0,0,2.091,7.988,15.7,15.7,0,0,0,13.82,7.9,16.293,16.293,0,0,0,9.969-3.389l2.531,2.817a19.681,19.681,0,0,1-5.964,3.3Z",
    transform: "translate(120.258 -109.456)",
    fill: "#1f252c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M119.023,155.135a19.771,19.771,0,0,1,7.306-7.262,21.164,21.164,0,0,1,20.554,0,19.179,19.179,0,0,1,7.262,7.262,19.97,19.97,0,0,1,2.619,10.035,19.719,19.719,0,0,1-9.925,17.3,20.149,20.149,0,0,1-10.321,2.663,20.763,20.763,0,0,1-10.321-2.575,18.726,18.726,0,0,1-7.218-7.13,20.281,20.281,0,0,1-2.619-10.277,19.683,19.683,0,0,1,2.663-10.035Zm3.983,18.177a15.317,15.317,0,0,0,5.678,5.81,15.525,15.525,0,0,0,15.713,0,15.8,15.8,0,0,0,5.678-5.81,16.08,16.08,0,0,0,2.091-8.032,16.387,16.387,0,0,0-2.091-8.1,15.281,15.281,0,0,0-5.678-5.854,14.994,14.994,0,0,0-7.856-2.135,14.823,14.823,0,0,0-7.944,2.267,16.384,16.384,0,0,0-7.636,13.82,16.322,16.322,0,0,0,2.091,8.032Z",
    transform: "translate(139.709 -109.672)",
    fill: "#1f252c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(115.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M167.191,0H149.434a2.958,2.958,0,0,0-2.954,2.954V20.711a2.948,2.948,0,0,0,2.954,2.954h17.757a2.958,2.958,0,0,0,2.954-2.954V2.954A2.948,2.948,0,0,0,167.191,0Z",
    transform: "translate(-28.184)",
    fill: "#009aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M211.407,22.226H193.65A2.958,2.958,0,0,0,190.7,25.18V40.3a70.667,70.667,0,0,0-41.343-17.837c-1.964-.16-3.96-.255-5.972-.255s-3.912.08-5.829.24a70.98,70.98,0,0,0-.16,141.467c1.964.16,3.96.255,5.972.255s3.912-.08,5.829-.24a70.567,70.567,0,0,0,41.487-17.853V161.2a2.948,2.948,0,0,0,2.954,2.954h17.757a2.958,2.958,0,0,0,2.954-2.954V25.18a2.948,2.948,0,0,0-2.954-2.954Zm-62.2,117.945a48.743,48.743,0,0,1-5.749.351H143.4a48.957,48.957,0,0,1-5.972-.367,47.327,47.327,0,0,1,.144-93.912,46.64,46.64,0,0,1,5.829-.351h.1a47.32,47.32,0,0,1,5.733,94.279Z",
    transform: "translate(-72.4 13.256)",
    fill: "#009aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M146.48,119.558v15.058c1.278-.878,2.539-1.8,3.753-2.763a83.327,83.327,0,0,0,19.9-22.516V66.67a70.764,70.764,0,0,1-23.65,52.888Z",
    transform: "translate(-28.184 39.793)",
    fill: "#3671a1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logoHorizontal.15fb280bae6d7cc3606394e6bb148a93.svg";
export { ForwardRef as ReactComponent };